import { useRecordContext } from "react-admin"

const OwnerTitle = () => {
  const record = useRecordContext()

  return <span>{record ? record.display_name : ""} [Co-Owner]</span>
}

export { OwnerTitle }
